export const getEnterExitClass = (isClosing: boolean, isEntering: boolean, enterClass: string, exitClass: string) =>
    isClosing ? exitClass : isEntering ? enterClass : undefined;
export const getEnterExitClass = (isClosing: boolean, isEntering: boolean, enterClass: string, exitClass: string) =>
    isClosing ? exitClass : isEntering ? enterClass : undefined;
